<template>
  <div class="col">
    <p>本隐私政策的目的是向用户（“用户”）提供有关个人数据处理目的、范围、处理时间以及使用tobook.link网站和移动应用程序（“tobook.link”, “应用”）和预订服务时的个人权利的信息。</p>
    <p>我们关心您的隐私和个人数据保护，因此根据适用法律 —— 2016年4月27日欧洲议会和理事会关于保护自然人在处理个人数据和自由流通这些数据方面的权利，并废除95/46/EC指令（通用数据保护条例）（“条例”）以及其他法律法规中规定的隐私和数据处理问题来处理您的个人数据。</p>
    <p>tobook.link保留随时修订和更改本政策的权利，特别是由于服务或适用法律和法规的变化。我们将通知您任何重大变化，您应定期审查本政策。</p>
    <h6 class="mt-5 mb-3">
      控制者及其联系信息
    </h6>
    <p>个人数据的控制者是tobook.link s.r.o.（注册号19608217），法定地址：Pavla Beneše 750/8, Praha 19900。您可以随时就与您的个人数据相关的问题或请求联系我们。</p>
    <h6 class="mt-5 mb-3">
      个人数据类别
    </h6>
    <p>身份数据 — 名字、姓氏、照片（可选）。联系信息 — 电话号码、电子邮件地址。我们不收集GDPR定义下的任何特殊类别的个人数据。</p>
    <h6 class="mt-5 mb-3">
      个人数据处理目的
    </h6>
    <ul>
      <h6 class="mt-4">
        <li>对于企业家和公司：</li>
      </h6>
      <p>1. 在tobook.link应用程序中注册（创建档案）。</p>
      <p>2. 准备关于使用tobook.link应用程序的匿名统计数据。</p>
      <p>3. 发送商业信息。</p>
      <p>4. 在在线预订聚合器中放置公司数据。通过使用tobook.link服务，您同意在我们拥有的在线预订聚合器中放置您公司的数据。这意味着我们可以使用您提供的数据进行在线预订您的服务，并提高我们服务的质量。</p>
      <h6 class="mt-4">
        <li>对于客户（预约）：</li>
      </h6>
      <p>1. 预订。您的个人数据以及预订详情，将存储在服务提供商的账户中，以查看和分析预订历史，以及基于法规要求和由此产生的义务的目的。</p>
      <p>2. 发送商业信息。</p>
    </ul>
    <h6 class="mt-5 mb-3">
      日志条目
    </h6>
    <p>请注意，每当在使用您的tobook.link应用程序时出现错误时，我们将借助第三方解决方案收集数据和信息 —— 日志条目 —— 来自您的手机。这些日志条目可能包括以下信息：设备的IP地址、设备名称、操作系统版本、您使用我们服务时的应用程序配置、使用服务的日期和时间以及其他统计数据。</p>
    <p>我们处理和收集这些信息是为了提高tobook.link应用的操作效率和用户体验。这些数据基于我们改善应用并为您提供更好服务的合法利益而处理。</p>
    <h6 class="mt-5 mb-3">
      支付处理
    </h6>
    <p>在Tobook.link上向第三方提供商支付服务时，支付通过我们的支付网关提供商Stripe处理。您将直接向Stripe提供信用卡或借记卡信息，Stripe操作一个安全服务器来处理支付详情，加密您的信用/借记卡信息并授权支付。Tobook.link不收集任何卡信息。</p>
    <p>您向Stripe提供的信息不受我们控制，受Stripe自己的<a href="https://stripe.com/en-cz/privacy" target="_blank">隐私政策</a>约束。</p>
    <p>在tobook.link上为个体企业家和公司提供的支付处理服务由Stripe提供，并受<a href="https://stripe.com/en-gb/legal/connect-account" target="_blank">Stripe连接账户协议</a>约束，该协议包括Stripe服务条款（统称为“<a href="https://stripe.com/en-gb/legal/ssa" target="_blank">Stripe服务协议</a>”）。通过同意协议或继续以个体企业家或公司身份在tobook.link上运营，您同意受Stripe服务协议的约束，Stripe可能不时修改同一协议。作为tobook.link通过Stripe启用支付处理服务的条件，您同意向tobook.link提供有关您和您的业务的准确和完整信息，并且您授权tobook.link共享与您使用Stripe提供的支付处理服务相关的交易信息。</p>
    <h6 class="mt-5 mb-3">
      个人数据的安全
    </h6>
    <p>在处理个人数据时，我们使用先进的技术解决方案并与安全服务提供商合作，评估隐私风险，并使用我们可用的组织和财务资源。我们对委托给我们的数据负责，并不收集或处理不必要的数据以提供我们的服务。</p>
    <p>我们的员工和商业伙伴仅出于上述目的使用数据，并受到严格的合同保密义务。</p>
    <p>个人数据将存储在安全的云计算和服务器解决方案中，这些解决方案提供在欧盟和欧洲经济区领土内的数据处理。在更换此类服务提供商时，我们始终保证只与确保符合条例要求的可靠合作伙伴合作。然而，我们提请您注意，没有任何电子存储方法是绝对安全、可靠和无瑕疵的，我们不能保证其绝对安全。</p>
    <h6 class="mt-5 mb-3">
      个人数据处理的法律依据
    </h6>
    <p>我们仅基于以下法律依据处理tobook.link应用用户的个人数据：</p>
    <ul>
      <li>您同意处理您的个人数据以用于一个或多个特定目的。</li>
      <li>数据处理对于与您签订协议或为了履行协议所必需，或者在签订协议之前应您的请求采取措施所必需。</li>
      <li>数据处理对于履行我们的法律义务所必需。</li>
      <li>数据处理对于保护您或他人的重大利益所必需。</li>
      <li>数据处理对于执行一项出于公共利益的任务所必需。</li>
      <li>数据处理对于我们或第三方的合法利益所必需，前提是这些利益不受您的利益或基本权利和自由的压倒。</li>
    </ul>
    <h6 class="mt-5 mb-3">
      个人数据保留期
    </h6>
    <p>我们存储个人数据的时间如下：</p>
    <ul>
      <li>
        数据对于其被收集的目的所必需的时间。
      </li>
      <li>
        数据主体和我们可以根据法律法规中规定的程序实现我们的合法利益（提交异议或在法庭上提起诉讼）。
      </li>
      <li>
        存在存储个人数据的法律义务。
      </li>
      <li>
        数据主体对相关处理个人数据的同意有效，除非有其他法律依据用于数据处理。
      </li>
    </ul>
    <p>在这些期间之后，您的个人数据将被永久删除或匿名化，以便不能再与您联系起来。</p>
    <h6 class="mt-5 mb-3">
      向第三方转让数据
    </h6>
    <p>为确保tobook.link应用的运行，我们使用以下第三方服务，这些服务可能处理您的个人数据（“处理者”）：</p>
    <!-- link -->
    <table-partners />
    <cite>*请阅读这些第三方的隐私政策以及它们如何处理您的数据。</cite>
    <p class="mt-1">
      我们不会向其他第三方披露您的个人数据，除非：
    </p>
    <ul>
      <li>根据您的明确和明确的同意；</li>
      <li>向法规中规定的人员披露，按照其中规定的程序和范围；</li>
      <li>在法规规定的情况下披露，以保护合法利益，例如检测、预防或调查潜在的欺诈、违反我们的条款或政策或其他非法活动，或保护我们的权利、财产或安全，或他人的权利、财产或安全。</li>
    </ul>
    <h6 class="mt-5 mb-3">
      链接到其他网站
    </h6>
    <p>tobook.link应用可能包含指向其他网站或应用的链接，这些网站或应用关于用户个人数据的处理规则不由tobook.link管理。因此，我们强烈建议您阅读这些网站的隐私政策。我们不控制或承担任何第三方网站或服务的内容和隐私政策的责任。</p>
    <h6 class="mt-5 mb-3">
      儿童隐私
    </h6>
    <p>tobook.link应用上可用的服务不适用于13岁以下的人。如果发现我们收到了13岁以下儿童的个人数据，我们将暂停tobook.link服务并从我们的系统中删除数据。如果您是该儿童的父母或监护人，并且知道您的孩子提供了个人信息，请联系我们，以便我们采取必要的行动。</p>
    <h6 class="mt-5 mb-3">
      商业通信
    </h6>
    <p>鉴于tobook.link与用户之间的法律关系，并根据条例，tobook.link可能会基于其合法利益发送商业通信。这些通信可能会发送有关与用户选择的预订和服务类型相关的服务和优惠。</p>
    <p>只有在用户同意接收此类通信时，才会向用户发送其他服务的商业通信。您有权随时通过使用电子邮件中的退订链接或直接联系我们来选择不接收这些通信。</p>
    <h6
      id="cookies"
      class="mt-5 mb-3"
    >
      "Cookies"
    </h6>
    <p>cookie是浏览网站时由浏览器在您的计算机或移动设备上存储的一小块数据。它允许服务器从您的浏览器收集信息，因此当您返回网站或从一个页面移动到另一个页面时，您不必总是重新输入数据。有关cookie如何工作的更多信息，请参阅网站<a target="_blank" href="http://www.cookiecentral.com">www.cookiecentral.com</a>。</p>
    <p>我们如何使用cookies？tobook.link应用使用cookies来提高服务质量，以及执行有关应用使用的匿名统计和获得的数据分析以用于市场营销目的。我们使用必要的cookies、会话cookies和分析cookies（第一方和第三方（合作伙伴）cookies）来：</p>
    <ul>
      <li>确保应用的安全并管理它。</li>
      <li>记住您应用的使用语言。</li>
      <li>记住您是否（或没有）同意使用cookies。</li>
      <li>帮助衡量营销活动的有效性。</li>
      <li>收集有关应用使用的信息，使我们能够衡量应用如何满足用户需求并进行必要的改进。</li>
      <li>一些cookies可能由第三方放置在您的计算机上 — 为我们的需求执行某些功能的服务提供商（例如，Google）。</li>
    </ul>
    <p>请注意，tobook.link应用还使用不需要您同意的cookies，这些cookies是：</p>
    <ul>
      <li>您输入的信息的cookies，仅在会话期间保留</li>
      <li>身份验证cookies，仅在会话期间保留。</li>
    </ul>
    <h6 class="mt-5 mb-3">
      个人数据及其传输
    </h6>
    <p>与cookies相关的信息不用于识别您个人。然而，我们可能会将这些信息与我们持有的关于您的其他信息链接，用于本政策中描述的目的。</p>
    <p>我们可能会与为我们提供服务的第三方分享您的数据，例如，tobook.link应用分析或客户服务。这些人员仅授权使用您的数据，以提供我们所需的这些服务。</p>
    <p>我们只会按照本隐私政策描述的方式向第三方提供您的数据。我们不以任何方式将您的数据出售给第三方。</p>
    <h6 class="mt-5 mb-3">
      您的权利
    </h6>
    <p>您有权随时请求有关您的个人数据的信息，检查存储的信息的准确性和/或更改或更新此信息。如果这些数据不再必要且我们无法根据法律保留它们，您还可以要求完全删除您的个人数据。</p>
    <p>在收到您的请求后的1个月内，我们将尽一切商业上合理的努力为您提供适当的个人数据访问，除非有特殊情况，在这种情况下，我们将通知您。</p>
    <p>为了保护您的隐私和安全，我们将采取适当措施验证您的身份，然后才提供您所请求的个人数据信息。</p>
    <h6 class="mt-5 mb-3">
      投诉
    </h6>
    <p>任何投诉和请求可以发送至：<a :to="{name: 'partners'}">tobook.link</a></p>
    <p>如果您认为我们侵犯了您的合法权利，您可以向数据国家监察机构提出投诉：Česká obchodní inspekce, Štěpánská 44, 110 00 Praha 1</p>
  </div>
</template>

<script>
import TablePartners from '@/components/policy/TablePartners.vue'

export default {
  name: 'CnPrivacyPolicy',
  components: {
    TablePartners,
  },
}
</script>

<style scoped>

</style>
